import { render } from "./ServicesOne.vue?vue&type=template&id=5b858f4a"
import script from "./ServicesOne.vue?vue&type=script&lang=js"
export * from "./ServicesOne.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__